import React, {Component} from 'react';
import {connect} from 'react-redux';
import Button from '../../Common/Button';
import ButtonGroup from '../../Common/ButtonGroup';
import AutoPaymentResetGuide from './AutoPaymentResetGuide';
import {fetchAndOpenAutoPaymentReCertificationPopup} from '../../../actions/purchase.actions';
import {fetchCurrentUserDetailRequest} from '../../../actions/user.actions';
import {patchUserAutoPayment} from '../../../actions/user.actions';
import {PAY_TOOL_NAME} from '../../../constants/purchase.constants';
import {PageContainer, PageTitle, Table} from '../../Common/PageComponents';

const stateToProps = state => {
  return {
    user: state.user,
  };
};

class AutoPaymentReset extends Component {
  constructor(props) {
    super(props);

    if (props.user.autoPayment && props.user.autoPayment.agreeForSmsService !== undefined) {
      this.state = {
        agreeForSmsService: props.user.agreeForSmsService,
      };
    }
  }

  componentDidMount() {
    this.props.dispatch(fetchCurrentUserDetailRequest());

    if (this.props.user.autoPayment && this.props.user.autoPayment.agreeForSmsService !== undefined) {
      this.setState({
        agreeForSmsService: this.props.user.agreeForSmsService,
      });
    }
  }

  _proceedAutoPayment(e) {
    e.preventDefault();

    this.props.dispatch(fetchAndOpenAutoPaymentReCertificationPopup());
  }

  _modifyAgreeForSmsService(e) {
    e.preventDefault();

    this.props.dispatch(
      patchUserAutoPayment({
        agreeForSmsService: this.state.agreeForSmsService,
      })
    );
  }

  _onAgreeForSmsServiceChanged(e) {
    this.setState({
      agreeForSmsService: e.target.value,
    });
  }

  _renderResetButton() {
    return (
      <ButtonGroup>
        <Button onClick={e => this._proceedAutoPayment(e)}>자동결제 재인증</Button>
      </ButtonGroup>
    );
  }

  _renderPayToolName() {
    if (!this.props.user.autoPayment) {
      return '신청된 자동결제가 없습니다.';
    }

    if (this.props.user.autoPayment.paused) {
      return '자동결제 일시정지';
    }

    return PAY_TOOL_NAME[this.props.user.autoPayment.paymentType];
  }

  _renderAgreeForSmsService() {
    return (
      <tr>
        <th style={{paddingTop: '4px'}}>
          새벽시간(00:00-07:00)
          <br />
          결제실패 안내 SMS 수신동의
        </th>
        <td colSpan={3}>
          <form>
            <input
              type="radio"
              name="agreeForSmsService"
              value={true}
              defaultChecked={this.props.user.autoPayment.agreeForSmsService}
              onChange={e => this._onAgreeForSmsServiceChanged(e)}
            />
            &nbsp;수신동의 &nbsp;&nbsp;
            <input
              type="radio"
              name="agreeForSmsService"
              value={false}
              defaultChecked={!this.props.user.autoPayment.agreeForSmsService}
              onChange={e => this._onAgreeForSmsServiceChanged(e)}
            />
            &nbsp;수신안함 &nbsp;&nbsp;
            <Button size="small" onClick={e => this._modifyAgreeForSmsService(e)}>
              변경
            </Button>
          </form>
        </td>
      </tr>
    );
  }

  render() {
    return (
      <PageContainer>
        <PageTitle title="자동결제 재인증">
          Home &gt; MY PC방 &gt; <strong> 자동결제 재인증</strong>
        </PageTitle>
        <Table theme={'form'} style={{marginBottom: '20px'}}>
          <colgroup>
            <col width={200} />
            <col width="*" />
            <col width={140} />
            <col width={260} />
          </colgroup>
          <tbody>
            <tr>
              <th>신청인명</th>
              <td>
                <label id="ownerName">{this.props.user.ownerName}</label>
              </td>
              <th>전화번호</th>
              <td>
                <label id="telephone">{this.props.user.mobile}</label>
              </td>
            </tr>
            <tr>
              <th>이메일</th>
              <td colSpan={3}>
                <label id="email">{this.props.user.email}</label>
              </td>
            </tr>
            <tr>
              <th>결제수단</th>
              <td colSpan={3}>
                <label style={{color: 'red'}}>{this._renderPayToolName()}</label>
              </td>
            </tr>
            {this.props.user.autoPayment && !this.props.user.autoPayment.paused
              ? this._renderAgreeForSmsService()
              : null}
          </tbody>
        </Table>
        <AutoPaymentResetGuide />
        {this.props.user.autoPayment && !this.props.user.autoPayment.paused ? this._renderResetButton() : null}
      </PageContainer>
    );
  }
}

export default connect(stateToProps)(AutoPaymentReset);
